import React  from 'react';
import { ItemHeadNodes } from '../ItemHeadNodes';
import { ItemNodes } from '../ItemNodes';
import './TableNodes.css';
import { size } from 'lodash';
export function TableNodes(props) {

    const { nodes, onReload, selectEntityNode, selectNetworkName, selectStatus } = props;

    const dataNodes = !selectEntityNode ? nodes : nodes
        .filter((value) => value.entity.toLowerCase()
        .includes(selectEntityNode.toLocaleLowerCase())) 
    
  return (
    <>
    
        <div className='table-nodes'>

            <table>
                <ItemHeadNodes />

                {  size(dataNodes) === 0?  <p>not results</p>:
                    dataNodes
                    .filter((value) =>{
                        if ( selectNetworkName && selectStatus) {
                            console.log("ALL" + selectNetworkName + selectStatus);
                        
                            return (
                                ( value.networkName === selectNetworkName || "Select" === selectNetworkName ) &&
                                ( value.status === selectStatus || "Select" === selectStatus )
                            );
                        } else if (selectNetworkName && selectStatus) {
                            return (
                                ( value.networkName === selectNetworkName || "Select" === selectNetworkName ) &&
                                ( value.status === selectStatus || "Select" === selectStatus )
                            );
                        } else if (selectNetworkName) {
                            return (value.networkName === selectNetworkName || selectNetworkName === "Select");
                        } else if (selectStatus) {
                            return (value.status === selectStatus || selectStatus === "Select");
                        } else {
                            return true;
                        }
                    })

                    .map((node) => (
                        <ItemNodes key={nodes._id} node={node} onReload={onReload} />
                    ))
                }
            </table>

        </div>
    
    </>
  )
}
